import { supportedDocumentFormats } from "@finway-group/shared/lib/consts/common"
import { UploadKindEnum } from "@finway-group/shared/lib/models"
import { Button, Form, Upload } from "antd"
import { type FormInstance } from "antd/lib/form"
import { type UploadFile } from "antd/lib/upload/interface"
import type { UploadRequestOption } from "rc-upload/lib/interface"
import React from "react"
import { Upload as UploadIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"
import { useExpense } from "~Shared/hooks/expense.hooks"
import { FileService, NotificationService } from "~Shared/services"
import { NotificationTypeEnum } from "~Shared/services/notification.service"

interface OfferDocumentUploadFormProps {
    isNew: boolean
    updateExpense: (updateValue: any) => void
    expenseForm: FormInstance
}
export const OfferDocumentUploadForm = ({ isNew, updateExpense }: OfferDocumentUploadFormProps) => {
    const { t } = useTranslation()

    const expenseDetails = useExpense()

    const doFileUpload = (req: UploadRequestOption<string>) => {
        const { file, onSuccess } = req
        if (!FileService.checkFileSizeAndHandleError(file as File)) {
            return
        }
        FileService.upload(file as File, UploadKindEnum.OFFER)
            .then((data) => {
                // onSuccess callback will update the 'response' field of uploaded file field.
                // ref: https://github.com/ant-design/ant-design/blob/a77684cbd97837a420a2f4d65e6a7cd9626af939/components/upload/Upload.tsx#L261
                onSuccess?.(data.url)
            })
            .catch(() => NotificationService.send(NotificationTypeEnum.ERROR, t("error:file.upload.title"), t("error:file.upload.message")))
    }

    const formatFileEvent = (e: any) => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const formatInitialFiles = (fileURLs?: Array<string>): Array<UploadFile> | undefined =>
        fileURLs?.map(
            (fileURL: string, index: number): UploadFile<string> => ({
                uid: uuidv4(),
                name: `Offer Document ${index + 1}`,
                status: "done",
                response: fileURL,
                type: "application/pdf",
                size: 4500,
            }),
        )

    return (
        <>
            <Form.Item key="offers" name="offers" getValueFromEvent={formatFileEvent} shouldUpdate valuePropName="">
                <Upload
                    defaultFileList={!isNew && expenseDetails ? formatInitialFiles(expenseDetails.offers) : []}
                    multiple
                    accept={supportedDocumentFormats.join(",")}
                    onChange={({ fileList }) => {
                        updateExpense({ offers: [...fileList] })
                    }}
                    beforeUpload={(file) => (FileService.checkIsFileExtensionValidAndShowNotification(file, supportedDocumentFormats) ? Promise.resolve() : Promise.reject())}
                    customRequest={(req: UploadRequestOption) => doFileUpload(req)}
                >
                    <Button className="text-left btn-default min-w-200 text-center">
                        <UploadIcon />
                        <span>{t("action:upload_offer")}</span>
                    </Button>
                </Upload>
            </Form.Item>
        </>
    )
}
